(function () {
  'use strict';

  var panel     = null;
  var hideTimer = null;
  var showTimer = null;

  // ── Show / hide ───────────────────────────────────────────
  function getHeaderBottom() {
    var hg = document.querySelector('header-group') ||
             document.querySelector('.header-group') ||
             document.querySelector('header');
    return hg ? hg.getBoundingClientRect().bottom : 80;
  }

  function getOppdagItem() {
    return document.querySelector('.kaay-oppdag-item');
  }

  function show() {
    clearTimeout(showTimer);
    // Re-build if panel was built with empty items (timing edge-case)
    var items = window.kaayMegaMenu || [];
    if (!panel || (panel.querySelectorAll('.kaay-mega-menu__card').length === 0 && items.length > 0)) {
      if (panel) panel.remove();
      panel = buildPanel(items);
    }
    clearTimeout(hideTimer);
    panel.style.top = getHeaderBottom() + 'px';
    panel.classList.add('is-visible');
    var item = getOppdagItem();
    if (item) item.classList.add('is-active');
  }

  function scheduleHide() {
    clearTimeout(showTimer);
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      if (panel) panel.classList.remove('is-visible');
      var item = getOppdagItem();
      if (item) item.classList.remove('is-active');
    }, 100);
  }

  // ── Build dropdown panel ──────────────────────────────────
  function buildPanel(items) {
    var el = document.createElement('div');
    el.className = 'kaay-mega-menu';
    el.id        = 'kaay-mega-menu';

    el.innerHTML =
      '<div class="kaay-mega-menu__inner">' +
        items.map(function (item) {
          return (
            '<a href="' + item.href + '" class="kaay-mega-menu__card">' +
              '<div class="kaay-mega-menu__img-wrap">' +
                (item.image
                  ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">'
                  : '') +
              '</div>' +
              '<span class="kaay-mega-menu__title">' + item.title + '</span>' +
            '</a>'
          );
        }).join('') +
      '</div>';

    el.addEventListener('mouseenter', function () { clearTimeout(showTimer); clearTimeout(hideTimer); });
    el.addEventListener('mouseleave', scheduleHide);
    document.body.appendChild(el);
    return el;
  }

  // ── Build and return the "Oppdag" trigger element ─────────
  function buildOppdagItem() {
    var wrapper = document.createElement('div');
    wrapper.className = 'kaay-oppdag-item';

    var a = document.createElement('a');
    a.href      = '#';
    a.className = 'kaay-oppdag-link';
    a.setAttribute('aria-haspopup', 'true');
    a.addEventListener('click', function (e) { e.preventDefault(); });

    var span = document.createElement('span');
    span.className   = 'kaay-oppdag-link-title';
    span.textContent = 'Oppdag';
    a.appendChild(span);

    wrapper.appendChild(a);
    wrapper.addEventListener('mouseenter', show);
    wrapper.addEventListener('mouseleave', scheduleHide);
    return wrapper;
  }

  // ── Build mobile drawer "Oppdag" accordion with image cards ─
  function buildMobileOppdagItem() {
    var items = window.kaayMegaMenu || [];
    var li = document.createElement('li');
    li.className = 'kaay-oppdag-mobile-item menu-drawer__list-item--deep';

    var details = document.createElement('details');
    details.id = 'kaay-oppdag-mobile-details';

    var summary = document.createElement('summary');
    summary.className = 'menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset';
    summary.innerHTML =
      '<span class="menu-drawer__menu-item-text wrap-text">Oppdag</span>' +
      '<span class="svg-wrapper icon-plus" style="pointer-events:none;">' +
        '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<line x1="7" y1="1" x2="7" y2="13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '<line x1="1" y1="7" x2="13" y2="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>' +
      '</span>';

    var ul = document.createElement('ul');
    ul.className = 'kaay-mobile-oppdag-cards details-content menu-drawer__menu menu-drawer__menu--childlist';
    ul.setAttribute('role', 'list');

    items.forEach(function (item) {
      var childLi = document.createElement('li');
      childLi.className = 'menu-drawer__list-item';

      var childA = document.createElement('a');
      childA.href = item.href;
      childA.className = 'kaay-mobile-oppdag-card focus-inset';

      var imgWrap = document.createElement('div');
      imgWrap.className = 'kaay-mobile-oppdag-card__img';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title;
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      }

      var titleEl = document.createElement('span');
      titleEl.className = 'kaay-mobile-oppdag-card__title';
      titleEl.textContent = item.title;

      childA.appendChild(imgWrap);
      childA.appendChild(titleEl);
      childLi.appendChild(childA);
      ul.appendChild(childLi);
    });

    details.appendChild(summary);
    details.appendChild(ul);
    li.appendChild(details);
    return li;
  }

  // ── Inject into .menu-list, after overflow-list ───────────
  // .menu-list is a plain <div> — not a web component. We inject here,
  // not inside overflow-list (which re-slots children) or header-menu
  // (which is a web component with its own lifecycle).
  function inject() {
    if (document.querySelector('.kaay-oppdag-item')) return true;

    var menuList = document.querySelector('.menu-list');
    if (!menuList) return false;

    menuList.appendChild(buildOppdagItem());
    return true;
  }

  // ── Inject Oppdag into mobile drawer ─────────────────────
  function injectMobile() {
    if (document.querySelector('.kaay-oppdag-mobile-item')) return true;

    var drawerMenu = document.querySelector('.menu-drawer__menu.has-submenu');
    if (!drawerMenu) return false;

    drawerMenu.appendChild(buildMobileOppdagItem());
    return true;
  }

  // ── Persistent guard against section-hydration wiping us ─
  // section-hydration.js runs morph() via requestIdleCallback after
  // page load. morph() removes DOM nodes that aren't in the server HTML.
  // This observer detects the removal and immediately re-injects.
  // After the one-time hydration (hydrated="true" flag), this never
  // fires again in normal browsing.
  function watchMenuList(menuList) {
    var observer = new MutationObserver(function () {
      if (!menuList.querySelector('.kaay-oppdag-item')) {
        menuList.appendChild(buildOppdagItem());
      }
    });
    observer.observe(menuList, { childList: true });
  }

  function watchDrawerMenu(drawerMenu) {
    var observer = new MutationObserver(function () {
      if (!drawerMenu.querySelector('.kaay-oppdag-mobile-item')) {
        drawerMenu.appendChild(buildMobileOppdagItem());
      }
    });
    observer.observe(drawerMenu, { childList: true });
  }

  // ── Init ──────────────────────────────────────────────────
  function init() {
    var menuList = document.querySelector('.menu-list');
    var drawerMenu = document.querySelector('.menu-drawer__menu.has-submenu');
    var ok = false;

    if (menuList) {
      inject();
      watchMenuList(menuList);
      ok = true;
    }
    if (drawerMenu) {
      injectMobile();
      watchDrawerMenu(drawerMenu);
      ok = true;
    }
    return ok;
  }

  // ── Wait for Fabric header to render ─────────────────────
  function waitForHeader() {
    if (init()) return;
    var observer = new MutationObserver(function () {
      if (init()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForHeader);
  } else {
    waitForHeader();
  }

})();
